import type { ReactNode } from 'react';

import HeroSectionContent from '../section-content';
import ResponsiveVideo from '../../responsive-video';
import styles from './styles.module.sass';
import type { ResponsiveVideoProps } from '../../responsive-video';

type HeroVideoSectionProps = {
  footer?: ReactNode;
  subtitle?: ReactNode;
  title: ReactNode;
  videoSrc: string;
  videoRenderOn?: ResponsiveVideoProps['renderOn'];
  videoTitle?: string;
};

const HeroVideoSection = ({ footer, subtitle, title, videoRenderOn, videoSrc, videoTitle }: HeroVideoSectionProps) => {
  const hasFooter = Boolean(footer);
  const content = <HeroSectionContent subtitle={subtitle} title={title} />;
  const footerClassName = hasFooter ? styles.withFooter : styles.withoutFooter;

  return (
    <div className={`${styles.videoSectionWrapper} ${footerClassName}`}>
      <div className={styles.videoContentWrapper}>
        <div className={styles.textColumnWrapper}>{content}</div>
        <div className={styles.videoColumnWrapper}>
          <ResponsiveVideo
            autoPlay
            className={styles.videoElement}
            muted
            playsInline
            renderOn={videoRenderOn}
            title={videoTitle}
          >
            <source src={videoSrc} type="video/mp4" />
          </ResponsiveVideo>
        </div>
      </div>
      {footer}
    </div>
  );
};

export default HeroVideoSection;
